import Loader from './class.loader.js';

class SceneManager {
    constructor() {

        /**
         * Modalità configuratore
         * 1 - Attitude
         * 2 - Grafica - Malta
         * 3 - Grafica - Velvet
         * 4 - Materials
         */
        this.appMode = 0;

        this.appModeNames = [
            'Frontali malta stampata Geometrica / Cement fronts with geometric printings',
            'Frontali malta stampata / Printed cement fronts',
            'Frontali velluto stampati / Printed velvet fronts',
            'Frontali tecnofiber stampati / Tecnofiber printed fronts',
            'Frontali lucidi stampati / Extra-glossy cement fronts',
            'Frontali malta laccata / Cement lacquered fronts'
        ];

        this.appModeTitle = this.appModeNames[0];

            this._canvas = document.getElementById('renderCanvas');
        this._engine = new BABYLON.Engine(this._canvas, true, {}, true);
        /*this._engine.setHardwareScalingLevel(0.1);*/
        window.addEventListener('resize', () => this.resize());

        //TODO DA METTERE TRUE IN PRODUZIONE
        BABYLON.Database.IDBStorageEnabled = false;
        this.createLoader();
        this.createScene();

        // modi globali
        this._topVisible = false;
        this._multiClickMode = true;
        this._showWireframe = false;
    }

    createLoader() {
        this._loader = document.createElement('div');
        this._loader.setAttribute('id', 'imergoLoader');
        let gif = document.createElement('img');
        gif.setAttribute('src', 'dist/assets/img/imergo_loader.gif');
        let h4 = document.createElement("h4");
        h4.textContent = "loading...";
        this._loader.appendChild(gif);
        this._loader.appendChild(h4);
        document.body.appendChild(this._loader);
    }

    createScene() {
        this._scene = new BABYLON.Scene(this._engine);
        this._scene.clearColor = new BABYLON.Color3(.9, .9, .9);

        /*this._scene.postProcessesEnabled = true;*/

        this._camera = new BABYLON.ArcRotateCamera('camera1', -(Math.PI / 2), 1, 500, new BABYLON.Vector3(0, 0, 0), this._scene);
        this._screenshotCamera = new BABYLON.ArcRotateCamera('screenshotCamera', -(Math.PI / 1.5), (Math.PI / 2), 400, new BABYLON.Vector3(0, 0, 0), this._scene);
        this._camera.setTarget(BABYLON.Vector3.Zero());
        this._camera.lowerRadiusLimit = 300;
        this._camera.upperRadiusLimit = 500;
        this._camera.attachControl(this._canvas, false);
        this._scene.activeCamera = this._camera;
        this._scene.constantlyUpdateMeshUnderPointer = true;

        this._url = "dist/assets/img/bg3.jpg";
        this._background = new BABYLON.Layer("back", this._url, this._scene);
        this._background.isBackground = true;

        /*this._scene.environmentTexture = new BABYLON.CubeTexture('./assets/img/env.env', this._scene);*/
        /*this._scene.environmentTexture = new BABYLON.CubeTexture.CreateFromPrefilteredData('./assets/img/env05.env', this._scene);*/
        // this._envHelper = this._scene.createDefaultEnvironment({
        //     createSkybox: false,
        //     createGround: false,
        //     environmentTexture: new BABYLON.CubeTexture.CreateFromPrefilteredData('./assets/img/env05.env', this._scene),
        //     cameraExposure:1,
        //     cameraContrast: 1,
        //     //toneMappingEnabled: true,
        // });


        // this._scene.debugLayer.show();

        // this._postProcess = new BABYLON.FxaaPostProcess("fxaa", 1.0, this._camera);

        this._light = new BABYLON.DirectionalLight('light', new BABYLON.Vector3(-1, -1, 2), this._scene);
        this._light.position = new BABYLON.Vector3(6, 1, 6);
        this._light.intensity = .9;
        /* this._light = new BABYLON.DirectionalLight('light', new BABYLON.Vector3(-1, 0, 2), this._scene);
         this._light.position = new BABYLON.Vector3(6, 6, 6);
         this._light.intensity = .75;*/

        this._filllight = new BABYLON.DirectionalLight('filllight', new BABYLON.Vector3(1, 0, -0.5), this._scene);
        this._filllight.position = new BABYLON.Vector3(-3, 1, -3);
        this._filllight.intensity = .5;

        this._hemilight = new BABYLON.HemisphericLight('hemilight', new BABYLON.Vector3(0, 5, 0), this._scene);
        this._hemilight.intensity = .5;

        // this._postProcess = new BABYLON.HighlightsPostProcess("highlights", 1.0, this._camera);

        // this._light = new BABYLON.SpotLight('light', new BABYLON.Vector3(200, 400, 200), new BABYLON.Vector3(-1, -2, -1), 1.1, 16, this._scene);
        // this._light.shadowMinZ = 0;
        // this._light.shadowMaxZ = 40;

        // this._ground = new BABYLON.MeshBuilder.CreateGround("ground", {height: 100, width: 100, subdivisions: 4}, this._scene);
        // this._ground.material = new BABYLON.StandardMaterial('pippo', this._scene);
        // this._ground.material.diffuseColor = new BABYLON.Color3(.8,.8,.8);
        // this._ground.receiveShadows = true;

        // this._cube = new BABYLON.Mesh.CreateBox("box", 20, this._scene);
        // this._cube.material = new BABYLON.StandardMaterial("cubemat", this._scene);
        // this._cube.material.diffuseColor = new BABYLON.Color3(1,0,0);
        // this._cube.position = new BABYLON.Vector3(0,10,0);

        // BUONA

        // this._shadowGenerator = new BABYLON.ShadowGenerator(1024, this._light);
        // this._shadowGenerator.forceBackFacesOnly = true;
        // this._shadowGenerator.usePercentageCloserFiltering = true;
        // this._shadowGenerator.bias = 0.001;

        // FINE BUONA

        //this._shadowGenerator.addShadowCaster(this._cube, true);
        //this._shadowGenerator.useBlurCloseExponentialShadowMap = true;
        //this._shadowGenerator.useKernelBlur = true;
        //this._shadowGenerator.blurKernel = 8;

        //this._shadowGenerator.useContactHardeningShadow = true;
        // this._shadowGenerator.filteringQuality = BABYLON.ShadowGenerator.QUALITY_LOW;


        // this._light2 = new BABYLON.HemisphericLight('light2', new BABYLON.Vector3(0,1,0), this._scene);
        // this._light2.diffuse = new BABYLON.Color3(.5, .5, .5);
        // this._light2.specular = new BABYLON.Color3(1, 1, 1);
        // this._light2.groundColor = new BABYLON.Color3(.2, .2, .2);

        this._assetsManager = new BABYLON.AssetsManager(this._scene);
        // this._assetsManager.useDefaultLoadingScreen = false;
        // this._engine.loadingUIText = "text";;
        // BABYLON.SceneLoader.ShowLoadingScreen = false;
        this._engine.loadingScreen = new Loader();
    }

    run() {
        /*this._assetsManager.load();
        this._assetsManager.onFinish = (tasks) => {
            this._engine.runRenderLoop( () => {
                this._scene.render();
            });
        }*/

        this._engine.runRenderLoop(() => {
            this._scene.render();
        });

    }

    resize() {
        this._engine.resize();
    }

    takeScreenshot(engine, camera) {
        let imageBase64;
        const picture = BABYLON.Tools.CreateScreenshotUsingRenderTarget(engine, camera, 1600, data => {
            imageBase64 = data;
        });

        return imageBase64;
    }

    toggleClickMode() {
        this._multiClickMode = !this._multiClickMode;
        document.getElementById('toggleClickMode').innerHTML = this._multiClickMode ? 'Griglia Geometrica / Geometric Grid' : 'Anta Intera / Full Front';
    }

    changeAppMode(mode) {
        this.appMode = mode;

        if (mode === 0) {
            this._showWireframe = false;
            this._multiClickMode = 1;
        } else if (mode === 1) {
            this._showWireframe = true;
            this._multiClickMode = 0;
        } else {
            this._multiClickMode = true;
            this._showWireframe = false;
        }
    }

    changeAppTitle(title) {
        this.appModeTitle = title;
    }
}

export const sceneManager = new SceneManager();

export default sceneManager;
